import { render } from "./PeripheralMetrics.vue?vue&type=template&id=ed7c6626&ts=true"
import script from "./PeripheralMetrics.vue?vue&type=script&lang=ts"
export * from "./PeripheralMetrics.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__